<template>
  <div
    v-if="open"
    class="fixed inset-0 z-40 bg-black/20 backdrop-blur-md lg:hidden"
    aria-hidden="true"
    @click="$emit('close')"
  />
</template>

<script>
export default {
  name: 'MobileOverlay',
  props: { open: Boolean },
  emits: ['close'],
}
</script>
